import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  button: {
    width: "100%",
    borderRadius: "14px",
    paddingBlock: "16px",
    border: "1px solid #d7dee7",
    backgroundColor: "#ffffff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "20px",
    color: "#083b5c",
    fontSize: "32px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    textTransform: "none",
    boxShadow: "none",
    minWidth: 0,
    [theme.breakpoints.down("xs")]: {
      height: "200px",
      gap: "14px",
      fontSize: "28px",
    },
  },
  buttonSelected: {
    borderColor: "#2BE65E",
    background: "linear-gradient(180deg, rgba(12, 222, 216, 0.1) 0%, rgba(38, 231, 116, 0.1) 100%)",
    boxShadow: "inset 0 0 0 1px #2BE65E",
  },
  buttonError: {
    borderColor: "#EF4444",
    boxShadow: "inset 0 0 0 1px #EF4444, 0 0 0 3px rgba(239, 68, 68, 0.1)",
  },
  label: {
    color: "#073857",
    fontSize: "35px",
    fontWeight: 700,
    lineHeight: 1.2,
    textAlign: "center",
    [theme.breakpoints.down("xs")]: {
      fontSize: "24px",
    },
  },
  icon: {
    lineHeight: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("xs")]: {
      transform: "scale(0.88)",
    },
  },
}));
